import React, { useState, useEffect } from "react";
import {
  Button,
  FormControl,
  MenuItem,
  Select,
  InputLabel,
  OutlinedInput,
  IconButton,
  InputAdornment,
} from "@mui/material";
import List from "./list";
import { Search } from "@mui/icons-material";
import getArticleService from "../../../services/getArticleService";
import { getCookie } from "../../../function";
import SearchIcon from "@mui/icons-material/Search";
import getJournalService from "../../../services/getJournalService";
import getFilterServices from "../../../services/getFilterServices";
import { useLocation, useNavigate } from "react-router-dom";

const ArticleList = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [journals, setJournals] = useState([]);
  const [manualJournals, setManualJournals] = useState([]);
  const [getdata, setGetData] = useState([]);
  const [filterVal, setFilterVal] = useState({
    pageNumber: 1,
    pageSize: 10,
    totalPages: 1,
    searchText: "",
    status: "",
    PublicationId: "",
    manualJournalId: "",
    id: getCookie("id"),
  });
  const { pageNumber, pageSize, searchText, status, PublicationId, manualJournalId } = filterVal;

  const location = useLocation();
  const navigate = useNavigate();

  const params = new URLSearchParams(location.search);
  const urlStatus = params.get("status");
  const computedStatus = urlStatus
    ? urlStatus.charAt(0).toUpperCase() + urlStatus.slice(1)
    : filterVal.status;

  const fetchData = async (customFilterVal = filterVal) => {
    let id = getCookie("id");
    try {
      const list = await getArticleService.getArticleByUserId(customFilterVal);
      console.log(list.articles);
      setFilterVal((prev) => ({ ...prev, totalPages: list.totalPages }));
      setGetData(list.articles); // Set the data to state currentPage
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  useEffect(() => {
    setFilterVal((prev) => {
      const newVal = {
        ...prev,
        status: computedStatus,
      };
      fetchData(newVal);
      return newVal;
    });
  }, [computedStatus, pageNumber, pageSize, searchText, PublicationId, manualJournalId]);

  console.log("pagenumber" , pageNumber)

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      setFilterVal((prev) => ({
        ...prev,
        searchText: searchTerm,
        pageNumber: 1,
      }));
    }, 400); // ✅ Wait 400ms before making an API call

    return () => clearTimeout(delayDebounce); // ✅ Clear timeout if user keeps typing
  }, [searchTerm]); // ✅ Runs only when searchTerm changes

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleStatusChange = (event) => {
    const newStatus = event.target.value;
    if (urlStatus !== null) {
      params.set("status", newStatus);
      navigate({ search: params.toString() }, { replace: true });
    } else {
      setFilterVal((prev) => ({
        ...prev,
        status: newStatus,
      }));
    }
  };

  const handleJournalChange = (event) => {
    console.log(event.target.value);
    setFilterVal({ ...filterVal, PublicationId: event.target.value });
  };

  const handleManualJournalChange = (event) => {
    console.log(event.target.value);
    setFilterVal({ ...filterVal, manualJournalId: event.target.value });
  };

  const fetchJournals = async () => {
    try {
      const list = await getJournalService.GetAllJournal();
      console.log("journallist", list);
      setJournals(list || []);
    } catch (error) {
      console.error("Error fetching journals:", error);
    }
  };

  const fetchManualJournals = async () => {
    try {
      const list = await getFilterServices.GetAllManualJournal();
      console.log("manualjournallist", list);
      setManualJournals(list || []);
    } catch (error) {
      console.error("Error fetching manual journals:", error);
    }
  };

  useEffect(() => {
    fetchJournals();
    fetchManualJournals();
  }, []);

  return (
    <div>
      <h3 style={{ margin: "10px" }}>Invoices</h3>
      <div className="d-flex justify-content-between mx-3 my-2">
        <div>
          <FormControl sx={{ m: 1, minWidth: 200 }} size="small">
            <Select
              labelId="journal-select-label"
              name="journal"
              displayEmpty
              value={PublicationId}
              onChange={handleJournalChange}
              MenuProps={{
                PaperProps: {
                  style: {
                    maxHeight: 350,
                  },
                },
              }}
            >
              <MenuItem value="">All Publications</MenuItem>
              {[...journals]
                .sort((a, b) => a.name.localeCompare(b.name))
                .map((j) => (
                  <MenuItem key={j.id} value={j.id}>
                    {j.name}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>

          <FormControl sx={{ m: 1, minWidth: 200 }} size="small">
            <Select
              labelId="manual-journal-select-label"
              name="manualJournal"
              displayEmpty
              value={manualJournalId}
              onChange={handleManualJournalChange}
              MenuProps={{
                PaperProps: {
                  style: {
                    maxHeight: 350,
                  },
                },
              }}
            >
              <MenuItem value="">All Journals</MenuItem>
              {[...manualJournals]
                .sort((a, b) => a.journalName.localeCompare(b.journalName))
                .map((j) => (
                  <MenuItem key={j.journalid} value={j.journalid}>
                    {j.journalName}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>

          <FormControl sx={{ m: 1, minWidth: 200 }} size="small">
            <Select
              labelId="demo-simple-select-label"
              name="status"
              displayEmpty
              value={computedStatus}
              onChange={handleStatusChange}
            >
              <MenuItem value="">All</MenuItem>
              <MenuItem value="Pending">Pending Paymemt</MenuItem>
              <MenuItem value="Confirmed">Confirmed Paymemt</MenuItem>
              <MenuItem value="Unconfirmed">Unconfirmed Paymemt</MenuItem>
            </Select>
          </FormControl>
        </div>
        <FormControl
          sx={{ m: 1, width: "25ch" }}
          variant="outlined"
          size="small"
        >
          <InputLabel htmlFor="outlined-adornment-password">Search</InputLabel>
          <OutlinedInput
            id="outlined-adornment-password"
            type="text"
            placeholder="Search By Id"
            name="search"
            value={filterVal.search}
            onChange={handleSearchChange}
            endAdornment={
              <InputAdornment position="end">
                <IconButton aria-label="toggle password visibility" edge="end">
                  <Search />
                </IconButton>
              </InputAdornment>
            }
            label="search"
          />
        </FormControl>
      </div>
      <List
        getdata={getdata}
        fetchData={fetchData}
        setFilterVal={setFilterVal}
        filterVal={filterVal}
      />
    </div>
  );
};

export default ArticleList;
